/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import {
  bolded,
  cardContainer,
  cardContainerSelected,
  cardImage,
  cardLink,
  cardSelector,
  cardTitle,
} from '../index.styles';

class Card extends SafePureComponent {
  constructor(props) {
    super(props);
    this.state = {
      extended: false,
    };
  }

  onHover = () => {
    this.setState({ extended: true }, () => {
      this.props.onHover();
    });
  };

  onLeave = () => {
    this.setState({ extended: false }, () => {
      this.props.onLeave();
    });
  };

  safeRender() {
    const { extended } = this.state;
    const { Item, onClick, selected } = this.props;
    const { Title, Image } = Item;
    return (
      <div
        id={Item.id}
        css={selected ? cardContainerSelected : cardContainer}
        onClick={onClick}
        onMouseLeave={this.onLeave}
        onMouseEnter={this.onHover}
      >
        {selected && <div css={cardSelector}></div>}
        <div>
          <img css={cardImage} src={Image.src} alt={Image.alt} />
        </div>
        <div>
          <h6
            css={[cardTitle, selected ? bolded : null]}
            dangerouslySetInnerHTML={{ __html: Title }}
          />
        </div>
      </div>
    );
  }
}

export default Card;
